import React from "react";
import { useTranslation } from "react-i18next";
import { CheckBox } from "@whatslly/ui-components/v2/BaseElements/CheckBox";
import styles from "./ConversationAssignmentCheckboxes.module.scss";

interface ConversationAssignmentCheckboxesProps {
  assignConversationToMe: boolean;
  setConversationToOpen: boolean;
  onAssignConversationToMeChange: () => void;
  onSetConversationToOpenChange: () => void;
}

export const ConversationAssignmentCheckboxes: React.FC<ConversationAssignmentCheckboxesProps> = ({
  assignConversationToMe,
  setConversationToOpen,
  onAssignConversationToMeChange,
  onSetConversationToOpenChange,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.checkboxRow}>
      <CheckBox
        checked={assignConversationToMe}
        onChange={onAssignConversationToMeChange}
        text={t("whatsapp_business_api_agent_page.opt_in.modal.assign_conversation_to_me")}
      />
      <CheckBox
        checked={setConversationToOpen}
        onChange={onSetConversationToOpenChange}
        text={t("whatsapp_business_api_agent_page.opt_in.modal.set_conversations_status_to_open")}
      />
    </div>
  );
};
